import { useParams, useLocation, Link } from 'react-router-dom'
import { ArrowLeft, MapPin } from 'lucide-react'
import BSDCard from '../BSDCard'
import DistrictMap from '../DistrictMap'
import { CDI_LIST } from '../../data/cdi'
import { CdiDetailContent } from '../StrutturaDetailDialog'

export default function CdiDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()
  const state = location.state as { from?: string } | null
  const backTo = state?.from || '/cdi'

  const cdi = slug ? CDI_LIST.find(c => c.id === slug) : undefined

  if (!cdi) {
    return (
      <div className="cdc-detail-page">
        <div className="cdc-detail-container">
          <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>
          <h1>CDI non trovato</h1>
        </div>
      </div>
    )
  }

  return (
    <div className="cdc-detail-page">
      <div className="cdc-detail-container">
        <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>
        <BSDCard kind="custom" className="cdc-detail-info-card" sezione="Centri Diurni Integrati" style={{ padding: 20 }}>
          <CdiDetailContent cdi={cdi} />
        </BSDCard>
        <BSDCard kind="custom" className="cdc-detail-map-card" sezione="Centri Diurni Integrati">
          <h2 className="cdc-detail-section-title"><MapPin size={16} /> Mappa del distretto</h2>
          <DistrictMap
            onSelectDistrict={() => {}}
            onClearSelection={() => {}}
            selectedDistrictId={cdi.ambitoId}
            allowDistrictSelection={false}
            showLegend={false}
            showInstructionText={false}
          />
        </BSDCard>
      </div>
    </div>
  )
}
